import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { detailsUser, updateUserProfile } from '../../redux/actions/userAction';
import { USER_UPDATE_PROFILE_RESET } from '../../redux/constant/userConstant';
import LoadingBox from '../../Component/LoadingBox';
import MessageBox from '../../Component/MessageBox';
import Button from '../../Component/Button/index';

//import './prfileScreen.less';
import '../SigninScreen/signinScreen.less';

// 1 Definimos la estructura del usuario
interface User {
  _id: string;
  name: string;
  email: string;
}

export default function ProfileScreen() {
  //2. Usamos el estado local para manejar los inputs (necesario en React para inputs controlados)
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  // 3. Tipamos el acceso a Redux
  const userSignin = useSelector((state: any) => state.userSignin);
  const { userInfo } = userSignin;

  const userDetails = useSelector((state: any) => state.userDetails);
  const { loading, error, user } = userDetails as {
    loading: boolean;
    error: string;
    user: User;
  };

  const userUpdateProfile = useSelector(
    (state: any) => state.userUpdateProfile
  );
  const {
    success: successUpdate,
    error: errorUpdate,
    loading: loadingUpdate,
  } = userUpdateProfile as {
    success: boolean;
    error: string;
    loading: boolean;
  };

  const dispatch = useDispatch<any>();

  useEffect(() => {
    dispatch({ type: USER_UPDATE_PROFILE_RESET });
    dispatch(detailsUser(userInfo._id));
  }, [dispatch, userInfo._id]);

  const submitHandler = (e: React.FormEvent) => {
    e.preventDefault();
    //dispatch update profile
    if (password !== confirmPassword) {
      alert('Password and Confirm Password Are Not Matched');
    } else {
      dispatch(
        updateUserProfile({
          //userId: user._id,
          name,
          email,
          password,
        })
      );
    }
  }; //

  // const submitHandler = (e: React.FormEvent) => {
  //   e.preventDefault();
  //   //dispatch uopdate profile
  // };

  // if (password !== confirmPassword) {
  //   alert('Password and Confirm Password are not match');
  // } else {
  //   dispatch(updateUserProfile({ userId: user._id, name, email, password }));
  // }

  /* esta const es para que la pagina no se arme haste que no dispatch regrese con datos */
  const isUserEmpty = !user || Object.keys(user).length === 0;

  return (
    <div>
      <form className="signin-form" onSubmit={submitHandler}>
        <div>
          {' '}
          <h1>Perfil de Usuario</h1>{' '}
        </div>
        {loading ? (
          <LoadingBox></LoadingBox>
        ) : error ? (
          <MessageBox variant="danger">{error}</MessageBox>
        ) : isUserEmpty ? (
          <MessageBox variant="danger">No hay datos disponibles</MessageBox>
        ) : (
          <>
            {loadingUpdate && <LoadingBox></LoadingBox>}
            {errorUpdate && (
              <MessageBox variant="danger">{errorUpdate}</MessageBox>
            )}
            {successUpdate && (
              <MessageBox variant="success">
                Perfil actualizado correctamente
              </MessageBox>
            )}

            <div>
              <label htmlFor="name">Nombre:</label>
              <input
                type="text"
                id="name"
                placeholder="Ingresar nombre"
                value={name}
                onChange={e => setName(e.target.value)}
              />
              <label htmlFor="email">Email:</label>
              <input
                type="email"
                id="email"
                placeholder="Ingresar email"
                value={email}
                onChange={e => setEmail(e.target.value)}
              />
              <label htmlFor="password">Contraseña:</label>
              <input
                type="password"
                id="password"
                placeholder="Ingresar contraseña"
                value={password}
                onChange={e => setPassword(e.target.value)}
              />
              <label htmlFor="confirmPassword">Confirmar Contraseña:</label>
              <input
                type="password"
                id="confirmPassword"
                placeholder="Confirmar contraseña"
                value={confirmPassword}
                onChange={e => setConfirmPassword(e.target.value)}
              />
            </div>
            <div>
                {/* <button type="submit" className="primary">
                  Actualizar Perfil
                </button> */}
                <Button type="submit"> Actualizar Perfil</Button>
            </div>
          </>
        )}
      </form>
    </div>
  );
}
